module.exports = __webpack_public_path__ + "img/loads-6.b0972330.jpg";